Runtime.Main = Class.create({
  initialize: function (controller) {
    this.controller = controller;
    this.loader = new Runtime.Loader(this.controller, document.getElementById('wrapper'));
    this.view = new Runtime.View(this.controller, {
      onToggleLock: code => this.toggleLock(code),
      onNavigate: id => this.updateUrl(id)
    });
    this.locked = false;
    document.observe('shell:showPaymentStatus', this.showPaymentStatus.bind(this));
    document.observe('shell:hidePaymentStatus', this.hidePaymentStatus.bind(this));
    this.connect();

    /* Attach help and sidebar */

    Help.attach(document.querySelector('#about'));
    Sidebar.attach(document.querySelector('#hamburger'));
    ConnectionStatus.attach(document.querySelector('.status'));
  },
  connect: function () {
    this.login(result => {
      switch (result) {
        case _CONNECTION_SUCCESS:
          window.sessionStorage.setItem('connection', 'online');
          this.success();
          break;
        case _CONNECTION_FAILED:
          this.logout();
          break;
        case _CONNECTION_TIMEDRIFT:
          this.warnAboutTimeDrift();
          break;
        case _CONNECTION_OFFLINE:
        case _CONNECTION_UNAVAILABLE:
        case _CONNECTION_UNKNOWN:
          ConnectionStatus.update(result);
          ConnectionStatus.showWindow();
          setTimeout(() => {
            this.retry();
          }, 1000 * (result == _CONNECTION_OFFLINE ? 15 : 60));
          window.sessionStorage.setItem('connection', 'offline');
          this.success();
          break;
        case _CONNECTION_UPGRADE:
          this.forceUpgrade();
          break;
      }
    });
  },
  retry: function () {
    this.login(result => {
      if (result == _CONNECTION_SUCCESS) {
        ConnectionStatus.update(result);
        window.sessionStorage.setItem('connection', 'online');
        this.success();
      }
      if (result == _CONNECTION_OFFLINE) {
        setTimeout(() => {
          this.retry();
        }, 1000 * 15);
      }
      if (result == _CONNECTION_UNAVAILABLE || result == _CONNECTION_UNKNOWN) {
        setTimeout(() => {
          this.retry();
        }, 1000 * 60);
      }
    });
  },
  login: async function (callback) {
    this.controller.account.login = JSON.parse(window.localStorage.getItem(this.controller.prefix() + 'login'));
    this.controller.account.permissions = JSON.parse(window.localStorage.getItem(this.controller.prefix() + 'permissions'));
    let client = this.controller.getClient();
    if (!client || !this.controller.account.login) {
      callback();
      return;
    }
    let token = window.localStorage.getItem(this.controller.prefix() + 'token') || null;
    let credentials;
    if (token) {
      credentials = `token=${token}`;
    } else {
      credentials = `client=${client}&user=${this.controller.account.login.username}&digest=${this.controller.account.login.password}`;
    }
    let url = `api/=${base32.stringify(credentials)}/Session.User/login`;
    new SafeApiLoader(url, {
      method: 'post',
      parameters: {
        version: Settings.version,
        guid: this.controller.settings.guid,
        details: JSON.stringify(await Runtime.System.get())
      },
      onSuccess: function (transport) {
        if (transport.status == 0) {
          // Failed to connect
          this.controller.account.client = client;
          callback(_CONNECTION_OFFLINE);
          return;
        }
        if (transport.responseText == '') {
          console.log('connection failed');
          callback(_CONNECTION_FAILED);
          return;
        }
        var response = JSON.parse(transport.responseText);
        if (response) {
          if (response.timestamp) {
            let diff = Math.abs(response.timestamp - moment().unix());
            if (diff > 15 * 60) {
              callback(_CONNECTION_TIMEDRIFT);
              return;
            }
          }
          this.controller.api = response.api;
          this.controller.tokens = Object.assign({
            'Session.*': token
          }, response.tokens);
          this.controller.keys = response.keys;
          this.controller.account.client = client;
          this.controller.account.permissions = response.permissions;
          this.controller.options = response.options || {};
          this.controller.messages = response.messages;
          if (response.tokens['Session.*'] && response.tokens['Session.*'] != token) {
            window.localStorage.setItem(this.controller.prefix() + 'token', response.tokens['Session.*']);
          }
          window.localStorage.setItem(this.controller.prefix() + 'permissions', JSON.stringify(this.controller.account.permissions));
          callback(_CONNECTION_SUCCESS);
        } else {
          /* To do: clear application show config screen */
          callback(_CONNECTION_FAILED);
        }
      }.bind(this),
      onFailure: function (transport) {
        switch (transport.status) {
          case 401:
            callback(_CONNECTION_FAILED);
            break;
          case 402:
            callback(_CONNECTION_FAILED);
            break;
          case 404:
            callback(_CONNECTION_UPGRADE);
            break;
          case 410:
            callback(_CONNECTION_UPGRADE);
            break;
          case 503:
            callback(_CONNECTION_UNAVAILABLE);
            break;
          default:
            callback(_CONNECTION_UNKNOWN);
            break;
        }
      }.bind(this)
    });
  },
  logout: function () {
    this.controller.account.login = {};
    this.controller.account.permissions = {};
    window.localStorage.removeItem('account');
    window.localStorage.removeItem(this.controller.prefix() + 'login');
    window.localStorage.removeItem(this.controller.prefix() + 'token');
    window.localStorage.removeItem(this.controller.prefix() + 'view');
    window.localStorage.removeItem(this.controller.prefix() + 'permissions');
    this.view.clear();
    this.controller.login();
    this.loader.destroy();
    Sidebar.destroy();
    this.updateUrl();

    /* On mobile we need to reload, in order restore our login viewport */
    if (System.Type.Mobile) {
      location.reload();
    }
  },
  success: function () {
    Runtime.resetViewport();
    var actors = this.controller.getActors();
    if (actors.length) {
      this.loader.bootstrap(actors[0]);
    }
    if (this.controller.options.newDesign) document.body.classList.add('newDesign');
    Banner.initialize(document.getElementById('banner'), this.controller);
    Sidebar.initialize(document.querySelector('ui-sidebar'), this.controller);
    Message.initialize(this.controller);
  },
  enableOverlay: function () {
    Overlay.count++;
    document.body.classList.add('overlay');
  },
  disableOverlay: function () {
    if (Overlay.count > 0) {
      Overlay.count--;
    }
    if (Overlay.count == 0) {
      document.body.classList.remove('overlay');
    }
  },
  updateUrl: function (view) {
    /* Disable updating URLs on webOS */

    if (navigator.userAgent.includes('NetCast')) {
      return;
    }
    let url = window.location.href.replace(window.location.search, '');
    let source = location.search.match(/source=([^&]*)/i);
    url += '?client=' + this.controller.account.client;
    if (this.loader.data) {
      if (this.loader.data.stage == 'salon') {
        url += '&salon=' + this.loader.data.actor;
        url += '&path=' + this.loader.data.stage + '/' + view;
      } else {
        url += '&path=' + this.loader.data.actor + '/' + view;
      }
    }
    if (source) {
      url += '&' + source[0];
    }
    if (window.history.replaceState) {
      window.history.replaceState(null, '', url);
    }
  },
  checkLock: function (code) {
    var lock = document.getElementById('lock');
    this.window = new ChallengeWindow(lock, {
      onCheck: value => value == code,
      onSave: data => {
        this.locked = false;
        Runtime.Loader.Platform.command('unlock', data);
        this.view.locked = false;
      }
    });
  },
  toggleLock: function (code) {
    if (this.locked) {
      this.checkLock(code);
    } else {
      this.locked = true;
      Runtime.Loader.Platform.command('lock');
      this.view.locked = true;
    }
  },
  showPaymentStatus: function () {
    if (this.paymentStatus == null) {
      this.paymentStatus = new Window.Status('Wachten op betaling...');
    }
  },
  hidePaymentStatus: function () {
    if (this.paymentStatus != null) {
      this.paymentStatus.close();
      this.paymentStatus = null;
    }
  },
  forceUpgrade: function () {
    new Window.Alert({
      message: "Upgrade nu!",
      explaination: "De versie van Salonhub die u gebruikt moet bijgewerkt worden voordat u verder kunt werken. Klik op OK om de nieuwste versie van Salonhub te installeren."
    });
  },
  warnAboutTimeDrift: function () {
    new Window.Alert({
      icon: {
        src: "Color#time-diff"
      },
      message: "Staat uw klok goed?",
      explaination: "Het lijkt er op dat de klok van uw computer verkeerd is ingesteld. Klopt de tijd wel? Dan is misschien de tijdzone verkeerd ingesteld. De klok van uw computer moet goed staan om Salonhub te kunnen gebruiken.",
      onClose: () => {
        this.connect();
      }
    });
  }
});
//# sourceMappingURL=main.js.map
